import React from 'react';

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import * as Sentry from '@sentry/react';
import R from 'core-js/stable';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';

import { AppProvider } from './contexts/AppContext';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import setupErrorHandlers from './setupErrorHandlers';
import SnackbarApp from './SnackbarApp';

const { REACT_APP_SENTRY_PROPAGATION_TARGETS, REACT_APP_SENTRY_ENVIRONMENT } = process.env;
const sentryPropagationTargets = REACT_APP_SENTRY_PROPAGATION_TARGETS ? REACT_APP_SENTRY_PROPAGATION_TARGETS.split(',') : [];

if (REACT_APP_SENTRY_ENVIRONMENT === 'production' || REACT_APP_SENTRY_ENVIRONMENT === 'test') {
  Sentry.init({
    dsn: 'https://620a7386c5e58f5df1ed580b38f26b3e@o1199599.ingest.us.sentry.io/4507698592677888',
    environment: REACT_APP_SENTRY_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    // Session Replay
    replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: sentryPropagationTargets,
  });
}

setupErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <BrowserRouter>
      <AppProvider>
        <SnackbarApp />
      </AppProvider>
    </BrowserRouter>
  </MuiPickersUtilsProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.unregister();

// eslint-disable-next-line babel/no-unused-expressions
R;
